export const getStringLookupCode = (benefitType: string) => {
  switch (benefitType) {
    case 'group_hospital_indemnity':
    case 'allstate_grp_medical':
    case 'colonial_group_hospital_confinement_indemnity_0':
    case 'colonial_group_hospital_confinement_indemnity_1':
    case 'colonial_group_hospital_confinement_indemnity_2':
    case 'colonial_group_hospital_confinement_indemnity_disabled':
    case 'colonial_group_hospital_confinement_indemnity_spouse':
    case 'unum_group_hospital_indemnity_employee':
      return 'hospitalIndemnity';
    case 'partner_market_place_pet_insurance':
      return 'petInsurance';
    case 'std':
      return 'std';
    case 'partner_market_place_legal':
    case 'legal':
      return 'legal';
    case 'partner_market_place_eap':
    case 'eap':
      return 'eap';
    case 'partner_market_place_home_auto':
      return 'homeAuto';
    case 'partner_market_place_identity':
    case 'id_theft':
      return 'identity';
    case 'accident_advance_coverage':
    case 'aflac_accidental':
    case 'allstate_grp_accident':
    case 'basic_add':
    case 'Rider_AD&D':
    case 'colonial_accident_0':
    case 'colonial_accident_1':
    case 'colonial_accident_2':
    case 'colonial_accident_child':
    case 'colonial_accident_child_1':
    case 'colonial_accident_child_2':
    case 'colonial_accident_child_3':
    case 'colonial_accident_spouse':
    case 'colonial_group_accident_0':
    case 'colonial_group_accident_1':
    case 'colonial_group_accident_disabled':
    case 'unum_group_accident_employee':
    case 'allstate_accident':
    case 'allstate_accident2':
    case 'add':
    case 'add_dep_only':
    case 'add_spouse_only':
      return 'accident';
    case 'critical_illness':
    case 'critical_illness_2':
    case 'critical_illness_3':
    case 'critical_assistance_advance_coverage':
      return 'criticalIllness';
    // need to implement one for permanent life, but mapping was not yet available
    default:
      return 'basic_subscriber_life';
  }
};
